import { Button, Stack, TextInput } from '@mantine/core';
import { useForm, yupResolver } from '@mantine/form';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { OtpRequestPayload } from '../../../../models/payload/auth';
import authSlice from '../../../../reducers/auth';
import { sendOtpForUser } from '../../../../reducers/otp';
import { AppDispatch, RootState } from '../../../../stores';
import PersianUtil from '../../../../utils/persianUtil';

interface ValuesType {
  phoneNumber: string;
}

const schema = Yup.object({
  phoneNumber: Yup.string()
    .matches(/^(0)9\d{9}$/, 'شماره وارد شده معتبر نیست.')
    .required('وارد کردن شماره تلفن همراه الزامی است.'),
});

const PhoneNumberDialogComponent = () => {
  const { loading } = useSelector((state: RootState) => state.otp);

  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(authSlice.actions.removeErrors());
  }, [dispatch]);

  const form = useForm<ValuesType>({
    initialValues: { phoneNumber: '' },
    validate: yupResolver(schema),
  });

  const onFormSubmit = form.onSubmit((values) => {
    const { phoneNumber } = values;
    const otpData: OtpRequestPayload = { phoneNumber };

    dispatch(sendOtpForUser(otpData));
  });

  return (
    <form onSubmit={onFormSubmit}>
      <Stack>
        <TextInput
          label="شماره تلفن همراه"
          description="شماره با ۰۹ شروع می‌شود"
          placeholder="09121234567"
          {...form.getInputProps('phoneNumber')}
          onChange={(val) =>
            form
              .getInputProps('phoneNumber')
              .onChange(PersianUtil.toEnglishNumbers(val.target.value.split(' ').join('')))
          }
        />

        <Button type="submit" disabled={!form.isValid()} loading={loading}>
          ادامه
        </Button>
      </Stack>
    </form>
  );
};

export default PhoneNumberDialogComponent;
